import { render, staticRenderFns } from "./ChapterEntryListInReadOnlyMode.vue?vue&type=template&id=79142492"
import script from "./ChapterEntryListInReadOnlyMode.vue?vue&type=script&lang=js"
export * from "./ChapterEntryListInReadOnlyMode.vue?vue&type=script&lang=js"
import style0 from "./ChapterEntryListInReadOnlyMode.vue?vue&type=style&index=0&id=79142492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports